module.exports = __webpack_public_path__ + "static/media/icon-add-circular.630e6527.svg";